const zodiacRanges: Record<string, { start: number; end: number }> = {
  'Mesha / Aries': { start: 0, end: 30 },
  'Vrishabha / Taurus': { start: 30.01, end: 60 },
  'Mithuna / Gemini': { start: 60.01, end: 90 },
  'Karkataka / Cancer': { start: 90.01, end: 120 },
  'Simha / Leo': { start: 120.01, end: 150 },
  'Kanya / Virgo': { start: 150.01, end: 180 },
  'Tula / Libra': { start: 180.01, end: 210 },
  'Vrishchika / Scorpio': { start: 210.01, end: 240 },
  'Dhanur / Sagittarius': { start: 240.01, end: 270 },
  'Makar / Capricorn': { start: 270.01, end: 300 },
  'Kumbha / Aquarius': { start: 300.01, end: 330 },
  'Meena / Pisces': { start: 330.01, end: 360 },
};

// export function formatDegree(sign: string, degree: number | string | null | undefined): string {
//   if (typeof degree !== 'number') return degree ? String(degree) : '-';

//   const zodiac = zodiacRanges[sign];
//   if (!zodiac) return `${degree.toFixed(2)}°`;

//   const relative = degree - zodiac.start;
//   if (relative < 0 || relative > 30) {
//     return `${degree.toFixed(2)}°`;
//   }

//   return `${relative.toFixed(2)}°`;
// }

export function formatDegree(sign: string, degree: number | string | null | undefined): string {
  if (degree === null || degree === undefined || degree === '' || Number.isNaN(Number(degree))) {
    return '-';
  }

  const deg = typeof degree === 'number' ? degree : Number(degree);

  if (Number.isNaN(deg)) return '-';

  const zodiac = zodiacRanges[sign];
  if (!zodiac) return `${deg.toFixed(2)}°`;

  const relative = deg - zodiac.start;
  if (relative < 0 || relative > 30) {
    return `${deg.toFixed(2)}°`;
  }

  return `${relative.toFixed(2)}°`;
}
